import {Box, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {getWaiver} from '../utils/WaiverApi';
import i18next from 'i18next';
import {useLoading} from '../../loading-overlay/LoadingContext';

export default function WaiverText() {
  const [waiverSection, setWaiverSection] = useState({});
  const {addToLoading} = useLoading();
  const language = i18next.language;

  const setWaiver = async () => {
    const promise = getWaiver(language);
    addToLoading(promise);
    const waiver = await promise;
    setWaiverSection(waiver);
  };

  useEffect(() => {
    setWaiver();
  }, []);

  return waiverSection.sections == null ? undefined : (
    <Box>
      {
        waiverSection.sections.map((section) =>
          <Box key={section.title}>
            <Typography variant='h6' title='title'>
              {section.title}
            </Typography>
            <Typography style={{whiteSpace: 'pre-wrap'}} title='section'>
              {section.content}
            </Typography>
          </Box>,
        )
      }
    </Box>
  );
}
